import { Routes } from '@angular/router';
import { LoginComponent } from './views/authentification/pages/login/login.component';
import { SelectSignatureComponent } from './views/authentification/pages/select-signature/select-signature.component';
import { MsalGuard } from '@azure/msal-angular';

export const routes: Routes = [
  {
    path: 'authentication',
    children: [
      {
        path: 'login',
        component: LoginComponent,
      },
      {
        path: 'login-failed',
        component: LoginComponent,
      },
      {
        path: 'select-signature',
        component: SelectSignatureComponent,
        canActivate: [MsalGuard],
      },
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: 'dashboard',
    canActivate: [MsalGuard],
    children: [
      {
        path: 'user-management',
        loadChildren: () =>
          import('./views/user-management/user-management-routing.module').then(
            m => m.UserManagementRoutingModule
          ),
      },
      {
        path: 'products',
        loadChildren: () =>
          import('./views/product/product-routing.module').then(
            m => m.ProductRoutingModule
          ),
      },
      {
        path: 'samples',
        loadChildren: () =>
          import('./views/sample/sample-routing.module').then(
            m => m.SampleRoutingModule
          ),
      },
      {
        path: 'diagnosis-scenarios',
        loadChildren: () =>
          import(
            './views/diagnosis-scenario/diagnosis-scenario-routing.module'
          ).then(m => m.DiagnosisScenarioRoutingModule),
      },
      {
        path: 'in-store-service',
        loadChildren: () =>
          import(
            './views/in-store-service/in-store-service-routing.module'
          ).then(m => m.InStoreServiceRoutingModule),
      },
      {
        path: 'gestures',
        loadChildren: () =>
          import('./views/gesture/gesture-routing.module').then(
            m => m.GestureRoutingModule
          ),
      },
      {
        path: 'catalogs',
        loadChildren: () =>
          import('./views/catalog/catalog-routing.module').then(
            m => m.CatalogRoutingModule
          ),
      },
      {
        path: 'languages',
        loadChildren: () =>
          import('./views/language/language-routing.module').then(
            m => m.LanguageRoutingModule
          ),
      },
      {
        path: 'beauty-advisors',
        loadChildren: () =>
          import('./views/beauty-advisor/beauty-advisor-routing.module').then(
            m => m.BeautyAdvisorRoutingModule
          ),
      },
      {
        path: 'pos',
        loadChildren: () =>
          import('./views/pos/pos-routing.module').then(
            m => m.PosRoutingModule
          ),
      },
      {
        path: 'app-features',
        loadChildren: () =>
          import('./views/app-feature/app-feature-routing.module').then(
            m => m.AppFeatureRoutingModule
          ),
      },
      {
        path: 'global',
        loadChildren: () =>
          import(
            './views/global-dashboard/global-dashboard-routing.module'
          ).then(m => m.GlobalDashboardRoutingModule),
      },
      {
        path: '',
        redirectTo: 'products',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '',
    redirectTo: 'authentication/login',
    pathMatch: 'full',
  },
];
